const jQ = jQuery.noConflict();

class Slider {
    constructor(sel, align = 'center', draggable = '>1', direction = 'next', autoPlay = false, freeScroll = false) {
        this.selector = sel;
        this.align = align;
        this.draggable = draggable;
        this.direction = direction;
        this.autoPlay = autoPlay;
        this.freeScroll = freeScroll;
    }
    init() {
        const {
            align, draggable, autoPlay, freeScroll,
        } = this;

        function slideSettings() {
            const el = jQ(this);
            const options = {
                wrapAround: true,
                pageDots: false,
                cellAlign: align,
                contain: true,
                draggable,
                autoPlay,
                pauseAutoPlayOnHover: false,
                prevNextButtons: true,
                imagesLoaded: true,
                freeScroll,
            };
            // enable prev/next buttons at 768px
            /*      if ( matchMedia('screen and (max-width: 768px)').matches ) {
                options.pageDots = true;
            } */
            el.flickity(options);
        }
        jQ(this.selector).each(slideSettings);
    }
}
const SimpleSlider = new Slider('.bc-gallery__slider');
const LightboxSlider = new Slider('.lightbox-gallery__slider');

export { SimpleSlider, LightboxSlider };
